export var StoreTargetEnum;
(function (StoreTargetEnum) {
    StoreTargetEnum["OFFLINE"] = "OFFLINE";
    StoreTargetEnum["ONLINE"] = "ONLINE";
    StoreTargetEnum["MIXT"] = "MIXT";
})(StoreTargetEnum || (StoreTargetEnum = {}));
//# sourceMappingURL=store-target.enum.js.map